import { render, staticRenderFns } from "./MemberGroupPreview.vue?vue&type=template&id=4af73ffe&scoped=true&"
import script from "./MemberGroupPreview.vue?vue&type=script&lang=ts&"
export * from "./MemberGroupPreview.vue?vue&type=script&lang=ts&"
import style0 from "./MemberGroupPreview.vue?vue&type=style&index=0&id=4af73ffe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af73ffe",
  null
  
)

export default component.exports